enum TaskCategory {
  Outstanding = 1,
  InProgress = 2,
  Done = 3,
  Archived = 4,
}

export { TaskCategory };
